export abstract class Mapper<TSource, TDestination> {
  abstract map(source: TSource): TDestination;

  mapArray(sources: TSource[]): TDestination[] {
    return sources.map(this.map);
  }

  protected mapNullable(source: TSource | null | undefined): TDestination | null {
    return source ? this.map(source) : null;
  }
}

export abstract class BiDirectionalMapper<TSource, TDestination> extends Mapper<TSource, TDestination> {
  abstract mapReverse(destination: TDestination): TSource;

  protected mapArrayReverse(destinations: TDestination[]): TSource[] {
    return destinations?.map(dest => this.mapReverse(dest)) ?? [];
  }
}
